module.exports = __webpack_public_path__ + "static/media/icono_bocadillo.f6c45b2d.png";